module.exports = __webpack_public_path__ + "static/img/torso9.e768a523.jpg";